<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <!-- MOBILE VIEW (Fintech Style) -->
    <div class="content d-lg-none mob-product-list">
        <!-- Header & Search -->
        <div class="px-2 mb-4">
           <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center gap-3">
                 <a href="javascript:void(0);" @click="router.push('/dashboard')" class="btn-back-mob shadow-sm">
                    <vue-feather type="arrow-left" size="20"></vue-feather>
                 </a>
                 <h4 class="fw-bold mb-0">Produk SDV</h4>
              </div>
               <button v-if="$hasPermission('ssp', 'products', 'create')" @click="openAddModal" class="btn btn-success-circle shadow-sm">
                  <vue-feather type="plus" size="20"></vue-feather>
               </button>
           </div>
           
           <div class="search-input-mob shadow-xs">
              <vue-feather type="search" size="18" class="text-muted"></vue-feather>
              <input type="text" v-model="searchQuery" placeholder="Cari Produk..." class="border-0 bg-transparent w-100 ms-2" />
           </div>
        </div>

        <!-- Product List Cards -->
        <div class="px-2 pb-5">
           <div v-if="filteredProducts.length > 0">
              <div 
                v-for="product in filteredProducts" 
                :key="'mob-prod-'+product.id" 
                class="mob-product-card mb-3 p-0 bg-white"
              >
                 <div class="px-3 pt-3 pb-2 d-flex justify-content-between align-items-center">
                    <span class="badge rounded-pill smallest px-2 py-1 uppercase" :class="product.status === 'active' ? 'bg-success-soft text-success' : 'bg-light text-muted'">{{ product.status === 'active' ? 'AKTIF' : 'NON-AKTIF' }}</span>
                     <div class="d-flex gap-2">
                        <button v-if="$hasPermission('ssp', 'products', 'edit')" @click="openEditModal(product)" class="btn-action-lite text-primary">
                           <vue-feather type="edit-3" size="14"></vue-feather>
                        </button>
                        <button v-if="$hasPermission('ssp', 'products', 'delete')" @click="showConfirmation(product.id)" class="btn-action-lite text-danger">
                           <vue-feather type="trash-2" size="14"></vue-feather>
                        </button>
                     </div>
                 </div>

                 <!-- Product Info -->
                 <div class="px-3 pb-3">
                    <h6 class="fw-bold text-dark mb-0 text-uppercase">{{ product.nama_produk }}</h6>
                 </div>
              </div>
           </div>
           
           <!-- Empty State Mobile -->
           <div v-else class="text-center py-5">
              <div class="bg-light p-4 rounded-circle d-inline-block mb-3">
                 <vue-feather type="package" class="text-muted" size="40"></vue-feather>
              </div>
              <p class="text-muted small">Tidak ada data Produk ditemukan.</p>
           </div>
        </div>
    </div>

    <!-- DESKTOP VIEW (Untouched) -->
    <div class="content d-none d-lg-block">
      <product-header></product-header>

      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input 
                  type="text" 
                  placeholder="Cari Produk..." 
                  class="dark-input" 
                  v-model="searchQuery"
                />
                <a href="javascript:void(0);" class="btn btn-searchset"
                  ><i data-feather="search" class="feather-search"></i
                ></a>
              </div>
            </div>
            <div class="search-path d-none d-md-block">
              <a
                class="btn btn-filter"
                id="filter_search"
                v-on:click="filter = !filter"
                :class="{ setclose: filter }"
              >
                <vue-feather type="filter" class="filter-icon"></vue-feather>
                <span><img src="@/assets/img/icons/closes.svg" alt="img" /></span>
              </a>
            </div>
            <div class="form-sort d-none d-md-flex">
              <vue-feather type="sliders" class="info-img"></vue-feather>
              <vue-select 
                :options="SortOptions" 
                v-model="sortOrder" 
                placeholder="Urutkan" 
                @select="sortOrder = $event.value"
              />
            </div>
          </div>
          <!-- /Filter -->
          <div
            class="card mb-0"
            :style="{ display: filter ? 'block' : 'none' }"
            id="filter_inputs"
          >
            <div class="card-body pb-3">
              <div class="row align-items-center">
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="input-blocks">
                    <vue-feather type="stop-circle" class="info-img"></vue-feather>
                    <vue-select
                      :options="StatusFilter"
                      v-model="statusFilter"
                      placeholder="Pilih Status"
                      @select="statusFilter = $event.value"
                    />
                  </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-12">
                  <div class="input-blocks">
                    <a class="btn btn-filters" @click="resetFilters">
                      <vue-feather type="rotate-ccw" class="me-1" style="width: 14px;"></vue-feather>
                      Reset
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Filter -->
          <div class="table-responsive product-list">
            <a-table
              class="table datanew table-hover table-center mb-0"
              :columns="columns"
              :data-source="filteredProducts"
              :loading="loading"
              :pagination="{
                pageSize: 5,
                showSizeChanger: false,
                position: ['bottomRight']
              }"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'Product'">
                  <a href="javascript:void(0);">{{ record.nama_produk }} </a>
                </template>

                <template v-else-if="column.key === 'status'">
                  <span class="badge" :class="record.status === 'active' ? 'badge-success' : 'badge-danger'">
                    {{ record.status }}
                  </span>
                </template>



                <template v-else-if="column.key === 'action'">
                  <td class="action-table-data">
                    <div class="edit-delete-action">
                      <a 
                        v-if="$hasPermission('ssp', 'products', 'edit')"
                        class="me-2 p-2" 
                        href="javascript:void(0);"
                        @click="openEditModal(record)"
                      >
                        <vue-feather type="edit" class="feather-edit"></vue-feather>
                      </a>
                      <a
                        v-if="$hasPermission('ssp', 'products', 'delete')"
                        class="confirm-text p-2"
                        @click="showConfirmation(record.id)"
                        href="javascript:void(0);"
                      >
                        <vue-feather type="trash-2" class="trash-2"></vue-feather>
                      </a>
                    </div>
                  </td>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>
  <edit-product-modal :product="selectedProduct"></edit-product-modal>
  <add-product-modal></add-product-modal>
</template>
<script>
import { useRouter } from "vue-router";
import { ref, computed, onMounted } from "vue";
import { useDataStore } from "@/store/dataStore";
import productService from "@/services/productService";
import ProductHeader from "./product-header.vue";
import EditProductModal from "@/components/modal/edit-product-modal.vue";
import AddProductModal from "@/components/modal/add-product-modal.vue";
import Swal from "sweetalert2";

const columns = [
  {
    title: "Nama Produk",
    dataIndex: "nama_produk",
    key: "Product",
    sorter: {
      compare: (a, b) => a.nama_produk.localeCompare(b.nama_produk),
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    sorter: {
      compare: (a, b) => a.status.localeCompare(b.status),
    },
  },
  {
    title: "Aksi",
    key: "action",
  },
];

export default {
  components: {
    ProductHeader,
    EditProductModal,
    AddProductModal
  },
  setup() {
    const router = useRouter();
    const filter = ref(false);
    const searchQuery = ref("");
    const selectedProduct = ref({});
    const statusFilter = ref(null);
    const sortOrder = ref("ASC");
    
    const { products, state, refreshData, loadAllData } = useDataStore();

    const openAddModal = () => {
       const btn = document.createElement('button');
       btn.setAttribute('data-bs-toggle', 'modal');
       btn.setAttribute('data-bs-target', '#add-product-modal');
       document.body.appendChild(btn);
       btn.click();
       document.body.removeChild(btn);
    };

    const openEditModal = (product) => {
       selectedProduct.value = { ...product };
       setTimeout(() => {
          const btn = document.createElement('button');
          btn.setAttribute('data-bs-toggle', 'modal');
          btn.setAttribute('data-bs-target', '#edit-product-modal');
          document.body.appendChild(btn);
          btn.click();
          document.body.removeChild(btn);
       }, 50);
    };
    
    const displayColumns = computed(() => {
      const baseColumns = [
        {
          title: "Nama Produk",
          dataIndex: "nama_produk",
          key: "Product",
          sorter: {
            compare: (a, b) => a.nama_produk.localeCompare(b.nama_produk),
          },
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          sorter: {
            compare: (a, b) => a.status.localeCompare(b.status),
          },
        },
      ];

      // Only show action column if user has edit OR delete permission
      const userStr = localStorage.getItem('currentUser');
      const user = userStr ? JSON.parse(userStr) : null;
      const isAdmin = user?.role === 'admin';
      const perms = user?.permissions?.ssp?.products || [];
      
      if (isAdmin || perms.includes('edit') || perms.includes('delete')) {
        baseColumns.push({
          title: "Aksi",
          key: "action",
        });
      }
      
      return baseColumns;
    });
    const loading = computed(() => state.isLoading && products.value.length === 0);

    const filteredProducts = computed(() => {
      let result = [...products.value];

      // 1. Search Query
      if (searchQuery.value) {
        const query = searchQuery.value.toLowerCase();
        result = result.filter(item => 
          item.nama_produk.toLowerCase().includes(query) ||
          (item.id && item.id.toString().includes(query))
        );
      }

      // 2. Status Filter
      if (statusFilter.value) {
        result = result.filter(item => item.status === statusFilter.value);
      }

      // 3. Sorting
      result.sort((a, b) => {
        const nameA = (a.nama_produk || "").toLowerCase();
        const nameB = (b.nama_produk || "").toLowerCase();
        if (sortOrder.value === "ASC") {
          return nameA.localeCompare(nameB);
        } else {
          return nameB.localeCompare(nameA);
        }
      });

      return result;
    });

    const resetFilters = () => {
      statusFilter.value = null;
      searchQuery.value = "";
    };

    const showConfirmation = (id) => {
      Swal.fire({
        title: "Apakah Anda yakin?",
        text: "Data yang dihapus tidak dapat dikembalikan!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, hapus!",
        cancelButtonText: "Batal",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await productService.deleteProduct(id);
            Swal.fire({
              icon: "success",
              title: "Berhasil Dihapus!",
              text: "Produk telah berhasil dihapus.",
              confirmButtonClass: "btn btn-success",
            });
            refreshData('products');
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Terjadi Kesalahan",
              text: "Gagal menghapus produk dari server",
              confirmButtonClass: "btn btn-danger",
            });
          }
        }
      });
    };

    const formatDate = (dateString) => {
      if (!dateString) return "-";
      return new Date(dateString).toLocaleDateString('id-ID', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    };

    onMounted(() => {
       if (products.value.length === 0) {
          loadAllData();
       }
    });

    return {
      filter,
      loading,
      filteredProducts,
      searchQuery,
      selectedProduct,
      columns: displayColumns,
      showConfirmation,
      formatDate,
      resetFilters,
      statusFilter,
      sortOrder,
      router,
      openAddModal,
      openEditModal,
      SortOptions: [
        { id: 'ASC', value: 'ASC', text: 'ASC (A-Z)' },
        { id: 'DESC', value: 'DESC', text: 'DESC (Z-A)' }
      ],
      StatusFilter: [
        { id: 'active', value: 'active', text: 'Aktif' },
        { id: 'inactive', value: 'inactive', text: 'Tidak Aktif' }
      ]
    };
  },
};
</script>

<style scoped>
/* Mobile Product List Styles */
.mob-product-list {
  padding-top: 15px !important;
  background: #fdfdfd;
}

.btn-back-mob {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e293b;
  border: 1px solid #f1f5f9;
  transition: all 0.2s;
}
.btn-back-mob:active {
  transform: scale(0.9);
  background: #f8fafc;
}

.btn-success-circle {
  width: 44px;
  height: 44px;
  background: #029147;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}

.search-input-mob {
  background: white;
  padding: 12px 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  border: 1px solid #f1f5f9;
}

.mob-product-card {
  background: white;
  border-radius: 20px;
  border: none !important;
  box-shadow: 0 8px 20px rgba(0,0,0,0.05);
  overflow: hidden;
  transition: all 0.2s ease;
}

.mob-product-card:active { 
  transform: translateY(2px) scale(0.98); 
  box-shadow: 0 4px 12px rgba(0,0,0,0.03);
}

.btn-action-lite {
  background: #f8fafc;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.btn-action-lite:active { transform: scale(0.9); }

.bg-success-soft { background: #ecfdf5; }

.uppercase { text-transform: uppercase; letter-spacing: 0.5px; }
.smallest { font-size: 10px; }

@media (max-width: 991.98px) {
  .page-header { display: none !important; }
}
</style>
